module.exports = __webpack_public_path__ + "components/advertise-markets/static/ad-desktop-0a127175aa01a92e3124925310472fa0.jpg";